<!DOCTYPE HTML>
<template>
<div class="project-details"
     v-if="project">
  <div class="cols">
    <div class="left">
      <CloseButton @close="close" />

      <div>
        <div class="uppercaseheader">Project</div>
        <h2>{{name}}</h2>
      </div>
      <div>
        <div class="uppercaseheader">Created on</div>
        <p>{{asShortDate(project.created)}}</p>
      </div>
      <div>
        <div class="uppercaseheader">Description</div>
        <p>{{project.description}}</p>
      </div>
    </div>

    <b-list-group class="right">

      <b-list-group-item v-if="project.budget">
        <div class="uppercaseheader">Budget</div>
        <div class="budget">
          {{asCurrency(project.budget)}}
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="project.timeline">
        <div class="uppercaseheader">Due date</div>
        <div>
          {{project.timeline}}
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="relevantSkills(project, userData).length > 0 ">
        <div class="uppercaseheader">Relevant skills</div>
        <div>
          <Pillgroup :items="relevantSkills(project, userData)"
                     variant="success"
                     :truncate="5" />
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="irrelevantSkills(project, userData).length > 0 ">
        <div class="uppercaseheader">Other skills</div>
        <div>
          <Pillgroup :items="irrelevantSkills(project, userData)"
                     :truncate="5" />
        </div>
      </b-list-group-item>

      <b-list-group-item>
        <div class="uppercaseheader">Client</div>
        <div>
          <VerificationBadge :status="project.verified" />
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="!currentStatus(project, userData)">
        <b-button variant="success"
                  @click="apply">1-click apply</b-button>
        <b-button variant="outline-light"
                  @click="hide"
                  size="sm">Not interested</b-button>
      </b-list-group-item>
      <b-list-group-item v-else
                         variant="warning">

        {{statusAsProvider(project, userData)}}
        <b-button variant="outline-light"
                  size="sm"
                  @click="undo">Undo</b-button>
      </b-list-group-item>
    </b-list-group>
  </div>


</div>
</template>

<script>
// Components
import Pillgroup from '@/components/Pillgroup.vue'
import VerificationBadge from '@/components/VerificationBadge.vue'
import CloseButton from '@/components/CloseButton.vue'
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProjectDetails',
  components: {
    Pillgroup,
    VerificationBadge,
    CloseButton,
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    userData: Object,
    project: Object,
  },
  data() {
    return {}
  },
  computed: {
    name() {
      return this.project.name
    }
  },
  methods: {
    apply() {
      this.changeStatus( this.project, this.userData, 'applied' )
    },
    undo() {
      this.changeStatus( this.project, this.userData )
    },
    hide() {
      this.changeStatus( this.project, this.userData, 'hidden' )
    },
    close() {
      this.$emit( 'close' )
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";
.project-details {
    .cols {
        display: grid;
        grid-template-columns: 3fr 2fr;
        grid-column-gap: 4rem;
        .left {
            display: grid;
            grid-row-gap: 1rem;
            align-content:: flex-start;

            p {
                font-family: 'Roboto';
                color: theme-color-level('primary',-5);
            }
        }
        .right {
            .list-group-item {
                display: grid;
                grid-row-gap: 0.5rem;

                .budget {
                    font-size: 1.5rem;
                }
            }
        }
    }
}
</style>
